export enum DeviceType {
  SMART_LOCK = 'SMART_LOCK',

  BT_BEACON = 'BT_BEACON',
}
